import { gql, useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { NOTIFICATION_TYPE, showNotification } from '@thinknet-gmbh/platform-common-ui';
import { GET_APPLICATION_BY_ID } from './get-application-by-id.hook';
import { GET_EAU_APPLICATIONS } from './get-applications.hook';

export const UPDATE_EAU_APPLICATIONS = gql`
  mutation updateStatusEauApplication($payload: UpdateEauApplicationInput!) {
    updateStatusEauApplication(payload: $payload) {
      _id
    }
  }
`;

export const useUpdateStatusEauApplication = ({ onSuccess }: { onSuccess?: () => void }) => {
  const { t } = useTranslation('applications');
  const [updateStatusEauApplication, { loading }] = useMutation(UPDATE_EAU_APPLICATIONS, {
    onCompleted: data => {
      if (data?.updateStatusEauApplication) {
        showNotification({
          isIcon: false,
          type: NOTIFICATION_TYPE.success,
          message: t('eAU.notifications.updated'),
        });
        if (onSuccess) {
          onSuccess();
        }
      }
    },
    refetchQueries: [GET_APPLICATION_BY_ID, GET_EAU_APPLICATIONS],
  });

  return { updateStatusEauApplication, loading };
};
